const isDevEnvironment = () => process.env.NODE_ENV !== 'production';

export default isDevEnvironment;
